/** Official GIS button, loaded only for an explicit Google identity attempt. */
interface IdentityAPI {
  initialize(options: { client_id: string; nonce: string; callback: (result: { credential: string }) => void; auto_select: boolean }): void;
  renderButton(parent: HTMLElement, options: { type: string; theme: string; size: string; text: string; width: number; locale: string }): void;
}
declare global { interface Window { google?: { accounts: { id: IdentityAPI } } } }
let loading: Promise<IdentityAPI> | undefined;
function load(): Promise<IdentityAPI> {
  if (window.google?.accounts.id) return Promise.resolve(window.google.accounts.id);
  if (loading) return loading;
  loading = new Promise<IdentityAPI>((resolve, reject) => {
    const script = document.createElement('script');
    const timer = window.setTimeout(() => fail(), 10000);
    const fail = () => { window.clearTimeout(timer); script.remove(); loading = undefined; reject(new Error('无法加载 Google 登录，请检查网络或使用邮箱登录')); };
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.onerror = fail;
    script.onload = () => {
      window.clearTimeout(timer);
      if (window.google?.accounts.id) resolve(window.google.accounts.id); else fail();
    };
    document.head.appendChild(script);
  });
  return loading;
}
export async function renderGoogleWebButton(parent: HTMLElement, clientId: string, nonce: string, onCredential: (credential: string) => void, isActive: () => boolean) {
  const api = await load();
  if (!isActive()) return;
  api.initialize({ client_id: clientId, nonce, auto_select: false, callback: result => { if (isActive()) onCredential(result.credential); } });
  api.renderButton(parent, { type: 'standard', theme: 'outline', size: 'large', text: 'continue_with', width: Math.min(parent.clientWidth || 320, 400), locale: 'zh_CN' });
}
